// @-Erwähnung in Notizen: reine Logik (Feinschliff 16.10.2026), mit node --test prüfbar.
import type { NutzerKurz } from "../api/types";

const normal = (s: string) => s.toLocaleLowerCase("de").normalize("NFD").replace(/[̀-ͯ]/g, "");

/** Rein: steht der Cursor in einem `@…`-Wort? Liefert Beginn des Wortes (Stelle des @) und den bisher getippten Teil. */
export function erwaehnungKontext(text: string, cursor: number): { von: number; suche: string } | null {
  const bis = text.slice(0, cursor);
  const m = /(?:^|[\s(])@([^\s@]{0,30})$/.exec(bis);
  if (!m) return null;
  return { von: cursor - m[1].length - 1, suche: m[1] };
}

/** Rein: die Form, in der ein Nutzer eingefügt wird (Vorname, bei gleichem Vornamen mit Nachname). */
export function erwaehnungText(u: NutzerKurz, alle: NutzerKurz[]): string {
  const vor = (u.first_name || u.name.split(" ")[0] || u.name).trim();
  const doppelt = alle.some((x) => x.id !== u.id && (x.first_name || x.name.split(" ")[0] || "").trim().toLocaleLowerCase("de") === vor.toLocaleLowerCase("de"));
  return doppelt ? u.name.trim() : vor;
}

/** Rein: Treffer für das getippte Stück (Vorname, Nachname oder ganzer Name enthält es). */
export function erwaehnungTreffer(nutzer: NutzerKurz[], suche: string): NutzerKurz[] {
  const n = normal(suche);
  return nutzer.filter((u) => u.is_active && (!n || normal(u.name).includes(n))).slice(0, 6);
}
